module.exports = __webpack_public_path__ + "static/media/desktop_illustration_side4_side5.b2d18936.png";